<template>
  <UkiModal :modalId="modalId" title="Колесо" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="wheel-item">Пункт колеса</label>
      <uki-select-control id="wheel-item"
                          :model-value="wheelItemId"
                          :options="wheelItems"
                          empty-title="Не выбран"
                          required="true"
                          @update:model-value="value => $emit('update:wheelItemId', value)"
      />
    </div>
    <div class="form-group">
      <label for="wheel-price">Колесо за</label>
      <uki-select-control id="wheel-price"
                          :model-value="wheelPrice"
                          :options="wheelPrices"
                          empty-title="Не выбрано"
                          required="true"
                          @update:model-value="value => $emit('update:wheelPrice', value)"
      />
    </div>
    <div class="form-group">
      <label for="wheel-comment">Комментарий</label>
      <textarea id="wheel-comment" :value="wheelComment" rows="4"
                @input="$emit('update:wheelComment', $event.target.value)">
      </textarea>
    </div>
  </UkiModal>
</template>

<script>
import UkiSelectControl from "@/components/UkiSelectControl";
import UkiModal from "@/components/UkiModal";

export default {
  name: "WheelModal",
  components: {UkiModal, UkiSelectControl},
  props: ["modalId", "wheelItems", "wheelPrices",
    "wheelItemId", "wheelPrice", "wheelComment"],
  emits: ["update:wheelItemId", "update:wheelPrice", "update:wheelComment", "close", "ok"]
}
</script>

<style scoped>

</style>